export default {
    title: 'Offer Management',
    tab_title: 'Internal Offers',
    sub_title: 'Offer Filter',
    list_title: 'Offer List',
    new: 'Add Offer',
    edit: 'Edit Offer',
    promoted_as_new: 'Offer promoted in the new items category',
    availability: {
        all: 'All counties',
        specific: 'Specific'
    },
    statuses: {
        active: 'Active',
        draft: 'Draft',
        deleted: 'Deleted',
        inactive: 'Inactive',
        in_review: 'Under Review',
        rejected: 'Awaiting Changes',
        expired: 'Expired'
    },
    export: {
        no_data_to_export: 'No data available for the selected filters'
    },
    types: {
        'discount': 'Discount',
        '1_1': '1+1',
        '1_50p': '1+50% discount',
        '2_1': '2+1',
        '2_50p': '2+ third item 50% off',
        '3_1': '3+1',
    },
    code_types: {
        file: 'File',
        text: 'Text',
    },
    partner_types: {
        intern: 'Internal',
        affiliated: 'Affiliated'
    },
    period_availability: {
        not_started: 'Before start date',
        in_interval: 'Active',
        exceed_last_day: 'Validity period expired'
    },
    modal: {
        confirm_save: 'Are you sure you want to save the changes?',
        confirm_leave: 'There are unsaved changes. Do you confirm leaving the page?',
        confirm_delete: 'Are you sure you want to delete this offer?',
        save_draft: 'Are you sure you want to save this offer as a draft?',
        publish: 'Are you sure you want to publish this offer?',
        confirm_activate: 'Are you sure you want to activate this offer?',
        confirm_inactivate: 'Are you sure you want to deactivate this offer?',
        confirm_rejected: 'Are you sure you want to reject this offer?',
        reject_reason: 'Offer rejection reason',
        success_message: 'Your offer is under review. You will receive an email with details regarding the approval process.'
    },
    fields: {
        name: 'Offer Title',
        value: 'Value',
        county: 'County',
        companies: 'Clients',
        type: 'Type',
        category: 'Category',
        categories: 'Categories',
        available_categories_clients: 'Client-specific categories',
        status: 'Status',
        county_availability: 'County Availability',
        country_availability: 'Country',
        brand_availability: 'Brand',
        responsible_consumption: 'Responsible Consumption',
        company_availability: 'Client Availability',
        available_locations: 'Available Locations',
        partner_types: 'Partner Type',
        partner_names: 'Partner Name',
        counties: 'Counties',
        description: 'Description',
        code_type: 'Code Type',
        code_value_t: 'Offer Code',
        code_value_f: 'File Code',
        download_current: 'Download current code',
        usage_instructions: 'Usage Instructions',
        date_availability: 'Validity Period',
        start_date: 'Start Date',
        end_date: 'End Date',
        created_at: 'Creation Date',
        affiliation_channel: 'Affiliation Channel',
        mapped_up_mobil: 'Mapped in UpMobil+',
        is_mapped: 'Mapped in',
        is_not_mapped: 'Unmapped in',
        contact: 'Contact',
        c_address: 'Address',
        c_phone: 'Phone Number',
        c_site: 'Website',
        partner: 'Partner',
        partner_data: 'Partner Information',
        partner_image: 'Partner Image',
        partner_name: 'Partner Name',
        partner_description: 'Partner Description',
        period_availability: 'Period Availability',
        description_placeholder: 'Offer description text. Minimum 50 characters. Maximum 3000 characters.',
        instructions_placeholder: 'Usage instructions text. Maximum 1000 characters.',
        mandatory_image: 'Mandatory image for offer operations'
    },
    tooltips: {
        instructions: 'Describe how the offer code can be used. Maximum 1000 characters per language.',
        description: 'Describe your offer. Maximum 3000 characters per language.',
        image: 'The image must be square and at least 500px per side. You may resize it using tools such as Paint, Adobe, etc.'
    },
    btn: {
        get_offer: 'Get Offer',
        back_to_categories: 'Back to Categories',
        export: 'Export Offers'
    },
    beneficiary: {
        title: 'Special Offers',
        available: 'Available Offers',
        no_offers: 'No offers available',
        code_is: 'Your code is:',
        available_between: 'Offer valid between {start_date} and {end_date}',
        offer_available_in: 'Offer available in the following counties',
        offer_available_in_all: 'Offer available in all counties',
    },
    company_availability: {
        0: 'Any client',
        1: 'Specific',
    },
    location_availability: {
        0: 'Anywhere',
        1: 'Online Platform',
        2: 'Physical Store'
    },
    type_list: 'Offer Administration',
    type_sort: 'Display Order Management',
    drag_and_drop: 'Drag to set display level',
    save_sort: 'Save Offer Order',
    attention_sentence:
        '<p>Attention!!!!!!!.</p>\n' +
        '                <p>This functionality is only for the UpMobil+ application.</p>\n' +
        '                <p>This functionality is not reflected on the Multiben website or the UpMobil app.</p>\n' +
        '                <p>If you’re not sure what to do, leave it as it is.</p>'
}